import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import redux from "redux";
import { TreeBranch } from "../../models/navigation";
import { AppState } from "../../store";
import { Utility } from "../../utils";
import { Paths } from "../../constants";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    navItems: state.nav.branches,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
});

interface OwnProps {
    active: boolean;
    id: number;
    separator: boolean;
    title: string;
    url: string;
}

interface ConnectedState {
    navItems: List<TreeBranch | undefined>;
}

interface ConnectedDispatch {
}

interface OwnState {
    children: List<TreeBranch | undefined>;
}

class MainMenuItemComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            children: List(),
        };
    }

    public render() {
        if (this.props.separator)
            return (<li className="separator"></li>);

        // only render immediate children for popup menus.
        const children = this.state.children.map((item, i) => {
            if (!item || !item.url)
                return null;

            const isSecondaryExternal = Utility.isExternalUrl(item.url);
            const secondaryLink = isSecondaryExternal
                ? <a href={item.url}>{item.title}</a>
                : <NavLink exact to={item.url}>{item.title}</NavLink>;

            return (
                <li className={item.active ? "current" : ""} key={i}>
                    {secondaryLink}
                </li>
            );
        });

        const isExternal = Utility.isExternalUrl(this.props.url);
        const link = isExternal
            ? <a href={this.props.url}>{this.props.title}</a>
            : <NavLink exact to={this.props.url}>{this.props.title}</NavLink>;

        return (
            <li className={this.props.active ? "current" : ""} onMouseEnter={() => this.onMouseEnter()} onMouseLeave={() => this.onMouseLeave()}>
                {link}
                {((): JSX.Element | null => {
                    return this.state.children.size
                        ? <ul>{children}</ul>
                        : null;
                })()}
            </li>
        );
    }

    private onMouseEnter() {
        // don't set children for home page
        if (this.props.url === Paths.Home)
            return;

        const children = this.props.navItems
            .filter((b, i) => b !== undefined && b.onNav && b.parentId === this.props.id)
            .sortBy((b) => b !== undefined && b.sort)
            .toList();

        this.setState({ ...this.state, children });
    }

    private onMouseLeave() {
        this.setState({ ...this.state, children: List() });
    }
}

export const MainMenuItem: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(MainMenuItemComponent);



// WEBPACK FOOTER //
// ./src/components/navigation/MainMenuItem.tsx